// Core
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
// Custom layout
import MainLayout from '../../../Layouts/Main'

//styles
import './styles.scss'

//assets
import assets from "../../../Assets";

//components
import InputBox from "Components/InputBox";
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import DropDownBox from "Components/Common/DropDownBox";
import Modal from 'Components/Common/Modal';
import Button from 'Components/Button';

//utils
import { notifySuccess } from 'Services/Utils/toastNotification';

//redux
import { useDispatch } from "react-redux";
import { deleteUser, fetchUserManagementCompany, fetchUserManagementIndustry, fetchUsersList, updateUserStatus } from '../../../Redux/Slices/userManagementSlice';

const UserManagement = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [userList, setUserList] = useState([]);
  //need to remove y after backend fixes in search
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPendingOnly, setShowPendingOnly] = useState(true);
  const [totalPendingUser, setTotalPendingUser] = useState("")
  const [userToDelete, setUserToDelete] = useState(null);
  const [search, setSearch] = useState('')
  const [openMenuId, setOpenMenuId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1)
  const [sortOptions, setSortOptions] = useState({ sort_by: false, order_by: "createdAt" });
  const [userStatus, setUserStatus] = useState(1)
  const [company, setCompany] = useState(null);
  const [industry, setIndustry] = useState(null);
  const [companyList, setCompanyList] = useState([]);
  const [industryList, setIndustryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const headerDetails = [
    {
      label: "S No",
      sortKey: false,
    },
    {
      label: "User Name",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "name" })
      },
    },
    {
      label: "Moblie Number",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "mobile" })
      },
    },
    {
      label: "Company Name",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "company_name" })
      },
    },
    {
      label: "Industry",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "industry_name" })
      },
    },
    {
      label: 'User status',
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "status" })
      },
    },
    {
      label: "Action",
      sortKey: false,
    },
  ]
  const dropDownStyles = {
    control: (provided) => ({
      ...provided,
      width: '200px',
      fontFamily: 'Roboto',
      color: '#697077',
      padding: '3px',
      border: 'none',
      borderRadius: 0,
      borderBottom: '1px solid #C1C7CD',
    }),
    menu: (provided) => ({
      ...provided,
      fontFamily: 'Roboto',
      color: '#697077',
    }),
    option: (provided) => ({
      ...provided,
      fontFamily: 'Roboto',
      color: '#697077',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontFamily: 'Roboto',
      color: 'black',
    }),
  }
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    setCurrentPage(1)
  }, [search, industry])

  useEffect(() => {
    dispatch(
      fetchUserManagementCompany({
        callBack: getCompanyCB,
      })
    )
    dispatch(
      fetchUserManagementIndustry({
        callBack: getIndustryCB,
      })
    )
  },[])

  useEffect(() => {
    setIsLoading(true)
    dispatch(
      fetchUsersList({
        data: {
          search: search,
          page: currentPage,
          limit: "10",
          sort_by: sortOptions.sort_by ? "ASC" : "DESC",
          order_by: sortOptions.order_by,
          companyId: company?.company_id || "",
          industryType: industry?.industry_type_id || "",
          getPendingOnly: showPendingOnly,
        },
        callBack: getUsersCB,
      })
    )
  }, [sortOptions, showPendingOnly, currentPage, userStatus, search, company, industry])

  const getCompanyCB = (value) => {
    // console.log(value.data)
    //add laabel and value for dropdown options
    const updatedCategories = value.data.map(item => ({
      ...item,
      label: item.company_name,
      value: item.company_id
    }));
    const additionalObject = {
      label: 'All Companies',
      value: '',
      company_name: 'All Companies'
    };
    setCompanyList([additionalObject, ...updatedCategories])
  }
  const getIndustryCB = (value) => {
    // console.log(value.data)
    //add laabel and value for dropdown options
    const updatedCategories = value.data.map(item => ({
      ...item,
      label: item.industry_name,
      value: item.industry_type_id
    }));
    const additionalObject = {
      label: 'All Industries',
      value: '',
      industry_name: 'All Industries'
    };
    setIndustryList([additionalObject, ...updatedCategories])
  }
  const getUsersCB = (value) => {
    // console.log(value.data.data_list)
    setUserList(value?.data?.data_list || [])
    setTotalPage(value?.data?.pageMeta?.totalPages)
    setTotalPendingUser(value?.data?.pageMeta?.total)
    setIsLoading(false)
    //add laabel and value for dropdown options
  }

  const handleOutsideClick = (e) => {
    // Check if clicked outside and if the menu is open
    if (openMenuId !== null && !e.target.closest(".optionsMenu")) {
      setOpenMenuId(null); // Close the menu if clicked outside
    }
  };

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
    // console.log(openMenuId)
  };

  useEffect(() => {
    // Add the event listener with a slight delay to allow the toggleMenu logic to complete
    const timer = setTimeout(() => {
      document.addEventListener("click", handleOutsideClick);
    }, 0);

    // Clean up event listener on unmount or when the component re-renders
    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [openMenuId]);

  // Function to show the modal
  const openDeleteConfirmationModal = (userId) => {
    setUserToDelete(userId);
    setIsModalOpen(true);
    setOpenMenuId(null)
  };

  const confirmDeleteUser = () => {
    if (userToDelete) {
      dispatch(
        deleteUser({
          data: { id: userToDelete },
          callBack: deleteUserCB,
        })
      );
      setIsModalOpen(false);
    }
  };

  const changeStatus = (status, id) => {
    // console.log(status,id)
    if ([1, 3, 4].includes(status)) {
      status = 2
    }
    else {
      status = 3
    }
    dispatch(
      updateUserStatus({
        data: {
          status: status,
          id: id
        },
        callBack: userStatusChangeCB,
      })
    )
  }

  const deleteUserCB = (value) => {
    console.log(value)
    notifySuccess("User Deleted Successfully")
    //triggers rerender after status change
    setUserStatus(!userStatus)
    //closes the options menu
    setOpenMenuId(null)
  }

  const userStatusChangeCB = (value) => {
    //triggers rerender after status change
    setUserStatus(!userStatus)
    //closes the options menu
    setOpenMenuId(null)
  };

  return (
    <MainLayout pageName={"User Management"}>
      <div className='ultra-user-management-container'>
        <div className="requestNavBar">
          <div className="requestOptionContainer">
            <div
              className={showPendingOnly ? "active-requestOptionContainerNav" : "requestOptionContainerNav"}
              onClick={() => setShowPendingOnly(true)}
            >
              Unmapped Users
              {showPendingOnly ? <span style={{
                marginLeft: "6px",
                fontWeight: "bold",
                fontSize: "14px",
                color: "#7E22CE",
                backgroundColor: "#F3E8FF",
                padding: "2px 8px",
                borderRadius: "12px",
              }}>{totalPendingUser}</span>
                : ""}
            </div>
          </div>
          <div className="requestOptionContainer">
            <div
              className={!showPendingOnly ? "active-requestOptionContainerNav" : "requestOptionContainerNav"}
              onClick={() => setShowPendingOnly(false)}
            >
              All Users
            </div>
          </div>
        </div>

        <div className='ultra-user-management-header'>
          <InputBox
            value={search}
            icon={assets.Icons.searchIcon}
            onChange={(e) => setSearch(e.target.value)}
            inputStyle={{
              padding: "1px 2vh 1px 7vh",
              border: "none",
              height: "43px",
              width: "25vw",
              borderRadius: "0px",
              borderBottom: '1px solid #C1C7CD',
              boxShadow: 'none',
              color: 'black'
            }}
          />
          <div className='ultra-user-management-filter'>
            {!showPendingOnly &&
              <DropDownBox
                title="company"
                placeholder="Select Company"
                options={companyList}
                onChange={(option) => {
                  setCompany(option);
                  setCurrentPage(1);
                }}
                value={company}
                customStyles={dropDownStyles}
              />}
            <DropDownBox
              title="industry"
              placeholder="Select Industry"
              options={industryList}
              onChange={(option) => {
                setIndustry(option);
                setCurrentPage(1)
              }}
              value={industry}
              customStyles={dropDownStyles}
            />
          </div>
        </div>
        <div className="ultra-user-management-table">
          <NormalTable headerDetails={headerDetails}>
            {userList.length > 0
              ? userList.map((user, index) => (
                <tr key={user.user_id} style={{ position: "relative" }}>
                  <td style={{ paddingLeft: "18px", }}>
                    {search ? index + 1 : (currentPage - 1) * 10 + (index + 1)}
                  </td>
                  <td style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                      src={user.image ? user.image : assets.Icons.avatar}
                      alt={user.userName}
                      style={{
                        height: '30px',
                        width: '30px',
                        borderRadius: '50%',
                        marginRight: '10px',
                      }}
                    />
                    {user.firstname.length > 25
                      ? `${user.firstname.substring(0, 25)}...`
                      : user.firstname}
                  </td>
                  <td>{user.country_code}&nbsp;{user.mobile}</td>
                  <td>{user.company_name}</td>
                  <td>{user.industry_name || "-"}</td>
                  <td style={{ color: user.status === 2 ? "#10CA23" : "#FF482F" }}>{user.status === 2 ? "Active" : user.status === 1 ? "Pending" : "Off Boarded"}</td>
                  <td>
                    <img
                      style={{ height: "15px", cursor: "pointer" }}
                      src={assets.Icons.optionsIcon}
                      alt="Options"
                      onClick={() => toggleMenu(user.user_id)}
                    />
                    {openMenuId === user.user_id && (
                      <div className="optionsMenuUser">
                        <ul>
                          <li onClick={() => navigate(`viewUser/${user.user_id}`)} ><img src={assets.Icons.viewIcon} alt="" />View</li>
                          <li onClick={() => navigate(`editUser/${user.user_id}`)}><img src={assets.Icons.editIcon} alt="" />Edit</li>
                          <li onClick={() => openDeleteConfirmationModal(user.user_id)}><img src={assets.Icons.deleteIcon} alt="" />Delete</li>
                          {user.status === 1 ? "" : <li onClick={() => changeStatus(user.status, user.user_id)}><img src={assets.Icons.activeInactiveIcon} alt="" />Mark as {user.status === 2 ? "OffBoard" : "Active"}</li>}
                        </ul>
                      </div>
                    )}
                  </td>
                </tr>
              )) : ''}
          </NormalTable>
          <Modal open={isModalOpen} closeModal={() => setIsModalOpen(false)}>
            <h3 style={{ textAlign: 'center', fontFamily: 'Roboto' }}>Are you sure you want to delete this user?</h3>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', paddingTop: '20px' }}>
              <Button
                buttonStyle={{
                  width: "40%",
                  height: "2vh",
                }}
                title='Delete'
                onClick={confirmDeleteUser}
              />
              <Button
                buttonStyle={{
                  height: "2vh",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid black",
                  width: "40%",
                }}
                titleStlye={{ color: "#888888" }}
                title="Cancel"
                onClick={() => setIsModalOpen(false)}
              />
            </div>
          </Modal>
        </div>
        {userList.length > 0 ? '' : <p style={{ textAlign: 'center', fontFamily: 'poppins', fontSize: "4vh", }}> {isLoading ? "Loading" : "No Data Found"} </p>}
        <div className="ultra-user-management-table-pagination">
          {userList.length > 0 ? <Pagination
            currentPage={currentPage}
            totalPages={totalPage}
            onPageChange={handlePageChange} /> : ''}
        </div>
      </div>
    </MainLayout>
  )
}

export default UserManagement
